<template>
  <div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="indexedItems"
            :search="search"
            item-key="id"
            class="elevation-1"
            show-expand
            :single-expand="true"
            :expanded.sync="expanded"
          >
            <template v-slot:item.no_profissional="{ item }">
              {{ item.no_profissional }}
              <span v-if="item.st_lotacao_ativa == 0" class="st-lotacao-inativa"
                >Sem lotação ativa</span
              >
            </template>

            <!-- <template #footer.prepend>
                    <v-spacer />
                  </template> -->
            <template v-slot:expanded-item="{ headers, item }">
              <td colspan="9">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>CNES</th>
                      <th>Unidade de saúde</th>
                      <th>INE</th>
                      <th>Equipe</th>
                      <th>Inativação</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(lotacao, index) in item.lotacoes" :key="index">
                      <td>
                        {{ lotacao.nu_cnes }}
                      </td>
                      <td>
                        {{ lotacao.no_unidade_saude }}
                      </td>
                      <td>{{ lotacao.nu_ine }}</td>
                      <td>
                        {{ lotacao.no_equipe }}
                      </td>
                      <td>
                        {{
                          lotacao.dt_desativacao != null
                            ? formatDate(lotacao.dt_desativacao)
                            : ''
                        }}
                      </td>
                      <td>
                        {{ lotacao.st_ativo == 1 ? 'Ativo' : 'Inativo' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-alert
                  v-if="exibirAlertaMultiploVinculo(item)"
                  variant="danger"
                  show
                >
                  O Agente de Saúde está ativo em mais de uma equipe.
                  Recomenda-se inativar o vínculo com a equipe anterior e
                  manter ativo apenas o vínculo com a equipe atual.
                  <br /><br />
                  Caso tenha ocorrido mudança de equipe, também será
                  necessário realizar a
                  <strong>Reterritorialização</strong>, disponível em
                  <strong>Gestão de Cadastros</strong>. O número da microárea
                  utilizado na equipe anterior pertence exclusivamente àquela
                  equipe, e os cadastros vinculados não são transferidos
                  automaticamente para a nova equipe do Agente de Saúde.
                </b-alert>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: '',
    },
  },
  mixins: [utils],
  data() {
    return {
      search: '',
      expanded: [],
      headers: [
        {
          text: 'Profissional',
          align: 'start',
          filterable: true,
          value: 'no_profissional',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: true,
          value: 'nu_cns',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: true,
          value: 'nu_cpf',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: true,
          value: 'no_cbo',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        let lotacoes = []

        if (item.lotacoes) {
          try {
            lotacoes =
              typeof item.lotacoes === 'string'
                ? JSON.parse(item.lotacoes)
                : item.lotacoes
          } catch (e) {
            lotacoes = []
          }
        }

        return {
          ...item,
          id: index,
          lotacoes,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Extrai o código do CBO de um profissional ou lotação.
     * @param {Object} registro
     * @returns {string}
     */
    obterCodigoCbo(registro) {
      if (!registro) return ''

      const codigo =
        registro.co_cbo ||
        registro.nu_cbo ||
        String(registro.no_cbo || '').match(/\d{6}/)?.[0] ||
        ''

      return String(codigo).trim()
    },

    /**
     * Exibe alerta quando o ACS/ACE está ativo em mais de uma equipe (INE).
     * @param {Object} item Profissional com lotações
     * @returns {boolean}
     */
    exibirAlertaMultiploVinculo(item) {
      // CBOs de ACS e Técnico em ACS
      const cbosPermitidos = ['515105', '322255']
      // CBO do profissional (nível raiz)
      const codigoCboProfissional = this.obterCodigoCbo(item)
      // Verifica se o CBO permitido está no profissional ou em alguma lotação
      const possuiCboPermitido =
        cbosPermitidos.includes(codigoCboProfissional) ||
        (item.lotacoes || []).some((lotacao) =>
          cbosPermitidos.includes(this.obterCodigoCbo(lotacao))
        )

      // Sem CBO permitido, não exibe o alerta
      if (!possuiCboPermitido) return false

      // INEs distintos das lotações ativas (ignora nulos/vazios)
      const inesAtivos = [
        ...new Set(
          (item.lotacoes || [])
            .filter((lotacao) => Number(lotacao.st_ativo) === 1)
            .map((lotacao) => lotacao.nu_ine)
            .filter((ine) => ine != null && String(ine).trim() !== '')
        ),
      ]

      // Exibe o alerta se houver mais de um INE ativo
      return inesAtivos.length > 1
    },
  },
}
</script>

<style lang="scss" scoped>
.st-lotacao-inativa {
  background: #d4d4db;
  border-radius: 20px;
  padding: 5px 10px;
  font-weight: 700;
  font-size: 11px;
}
</style>
